import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderInputs, commonAddressInputs, commonPersonInputs } from "./utils";
import { useSubmit } from "module/common/components/forms";
import { putPerson } from "module/main/store/appEndpoints/api";
var Person = function (_a) {
    var formSubmitCallBack = _a.formSubmitCallBack, formRef = _a.formRef;
    var handleSubmit = useSubmit(function (request) {
        var street = request.street, city = request.city, state = request.state, zipcode = request.zipcode;
        var hasMailing = [street, city, state, zipcode].some(Boolean);
        var mailing_addresses = hasMailing
            ? [
                {
                    street: street || null,
                    city: city || null,
                    state: state || null,
                    zipcode: zipcode || null,
                },
            ]
            : [];
        var curatedPayload = {
            person_lookups: [
                {
                    first_name: request.first_name || null,
                    middle_name: request.middle_name || null,
                    last_name: request.last_name || null,
                    age: request.age || null,
                    email: request.email || null,
                    phone_number: request.phone_number || null,
                    mailing_addresses: mailing_addresses,
                },
            ],
        };
        formSubmitCallBack(putPerson, curatedPayload);
    });
    var personInputs = renderInputs(commonPersonInputs);
    var mailingInputs1 = renderInputs(commonAddressInputs.slice(0, 2));
    var mailingInputs2 = renderInputs(commonAddressInputs.slice(2));
    var restInputs = [
        { id: "age", name: "age", placeholder: "Enter Age", label: "Age", type: "number" },
        { id: "email", name: "email", placeholder: "Enter Email", label: "Email", type: "email" },
        {
            id: "phone_number",
            name: "phone_number",
            placeholder: "Enter Phone Number",
            label: "Phone Number",
            type: "tel",
        },
    ];
    var restInputFields1 = renderInputs(restInputs.slice(0, 2), "person");
    var restInputFields2 = renderInputs(restInputs.slice(2), "person");
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "Person lookup:" }), _jsx("div", { className: "form-row", children: personInputs }), _jsx("div", { className: "form-row", children: restInputFields1 }), _jsx("div", { className: "form-row", children: restInputFields2 }), _jsx("h5", { className: "font-bold mb-2 inline", children: "Mailing addresses:" }), _jsx("div", { className: "form-row", children: mailingInputs1 }), _jsx("div", { className: "form-row", children: mailingInputs2 })] }));
};
export default Person;
